module.exports = "/_next/static/images/e1b9198d72228c4b33216e9faddd8d88-mockup-transfer-fgts@0.75x.jpg";